import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { type DotVariant } from './dot.model';

@Component({
  selector: 'dpqa-dot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dot.component.html',
  styleUrl: './dot.component.less',
})
export class DotComponent {
  variant = input<DotVariant>('default');
}
